import { computed } from 'vue';
import { deviceTypes } from '@utils/constants';
import { useDevice } from '@modules/discovery/composables';
import { DeviceClasses, ComputedRef } from '../types/sortable-grid.definitions'; // eslint-disable-line no-unused-vars

const googleAdOnIngridTopBannerClasses = {
  [deviceTypes.DESKTOP]: 'googleAdOnSearchInline_3',
  [deviceTypes.PHONE]: 'googleAdOnSearchMobileInline_3',
};

const googleAdOnIngridMidBannerClasses = {
  [deviceTypes.DESKTOP]: 'googleAdOnSearchInline_6',
  [deviceTypes.PHONE]: 'googleAdOnSearchMobileInline_6',
};

const googleAdOnIngridBottomBannerClasses = {
  [deviceTypes.DESKTOP]: 'googleAdOnSearchInline_9',
  [deviceTypes.PHONE]: 'googleAdOnSearchMobileInline_9',
};

/**
 *
 * @param {{ googleAdOnIngridTopBanner: DeviceClasses, googleAdOnIngridMidBanner: DeviceClasses, googleAdOnIngridBottomBanner: DeviceClasses }} param0
 * @returns {{id: ComputedRef<string>}}
 */
export default function useGoogleAdId({ googleAdOnIngridTopBanner, googleAdOnIngridMidBanner, googleAdOnIngridBottomBanner }) {
  const { isPhone } = useDevice();

  const id = computed(() => {
    /* istanbul ignore else */
    if (googleAdOnIngridTopBanner) {
      return isPhone ? googleAdOnIngridTopBannerClasses[deviceTypes.PHONE] : googleAdOnIngridTopBannerClasses[deviceTypes.DESKTOP];
    }
    /* istanbul ignore else */
    if (googleAdOnIngridMidBanner) {
      return isPhone ? googleAdOnIngridMidBannerClasses[deviceTypes.PHONE] : googleAdOnIngridMidBannerClasses[deviceTypes.DESKTOP];
    }
    /* istanbul ignore else */
    if (googleAdOnIngridBottomBanner) {
      return isPhone ? googleAdOnIngridBottomBannerClasses[deviceTypes.PHONE] : googleAdOnIngridBottomBannerClasses[deviceTypes.DESKTOP];
    }

    return '';
  });

  return {
    id,
  };
}
